/**
 * Map link of the contacts block. Map services give an <iframe> code to embed a map; its src is the address.
 * The server stores the address the same way, here it also serves the unsaved preview.
 */
export const mapUrl = (value: string): string =>
    value.match(/<iframe[^>]*\ssrc\s*=\s*["']([^"']+)["']/i)?.[1].replaceAll('&amp;', '&') ?? value.trim();

const EMBEDDABLE = [
    { host: /(^|\.)google\.[a-z.]+$/, path: '/maps/embed' },
    { host: /(^|\.)yandex\.[a-z.]+$/, path: '/map-widget/' },
];

/**
 * Only embed addresses can be shown in a frame: map services refuse to be framed by share links
 * like maps.app.goo.gl, so those open in a new tab instead.
 */
export const isEmbeddableMap = (url: string): boolean => {
    try {
        const { hostname, pathname } = new URL(url);

        return EMBEDDABLE.some((service) => service.host.test(hostname) && pathname.startsWith(service.path));
    } catch {
        return false;
    }
};
